import { render, staticRenderFns } from "./AssetsUpload.vue?vue&type=template&id=33903530"
import script from "./AssetsUpload.vue?vue&type=script&lang=js"
export * from "./AssetsUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports